import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import Checkbox from '@components/common/checkbox/main';
import { get as getSections } from '@api/v4/brandfolders/sections';

function ScopeSectionSelection({ updateScope, scope }) {
  const [scopeResources, updateScopeResources] = useState([]);
  const [selectedKeys, updateSelectedKeys] = useState([]);
  const [scopableSearch, updateScopableSearch] = useState('');
  const [allScopableSelected, updateAllSelected] = useState(false);

  useEffect(() => {
    getSections().then((resources) => {
      updateScopeResources(resources);
    });
    updateSelectedKeys(scope?.section_keys || []);
  }, []);

  const renderScopableSearch = () => {
    const hideCloseClass = scopableSearch === '' ? 'hide-close' : '';
    return (
      <div className="add-resource-search-container">
        <span
          className={`icon bff-close ${hideCloseClass}`}
          onClick={() => updateScopableSearch('')}
          role="button"
          tabIndex={0}
        />
        <input
          className="searchbar add-resource-search"
          onChange={(e) => { updateScopableSearch(e.target.value); }}
          placeholder={t("Search Sections")}
          type="text"
          value={scopableSearch}
        />
      </div>
    );
  };

  const handleActionableUpdates = (key) => {
    const selections = new Set(selectedKeys);
    if (selections.has(key)) {
      selections.delete(key);
    } else {
      selections.add(key);
    }
    updateSelectedKeys([...selections]);
    if (selections.size < 1) {
      updateScope(null);
    } else {
      updateScope({ section_keys: [...selections] });
    }
  };

  const formattedCheckboxes = () => {
    const sortedResources = [...scopeResources].sort((a, b) => {
      if (a.attributes.name.toUpperCase() > b.attributes.name.toUpperCase()) {
        return 1;
      }
      if (b.attributes.name.toUpperCase() > a.attributes.name.toUpperCase()) {
        return -1;
      }
      return 0;
    });
    const displayedActionables = [];

    for (let i = 0; i < sortedResources.length; i += 1) {
      const resource = sortedResources[i];
      const displayActionable = resource.attributes.name.toUpperCase().indexOf(scopableSearch.toUpperCase()) > -1;

      if (displayActionable) {
        displayedActionables.push(
          <li className="checkbox-container" key={i}>
            <Checkbox
              checked={selectedKeys.indexOf(resource.id) > -1}
              labelHtml={<h5> {resource.attributes.name} </h5>}
              size="sm"
              toggle={() => handleActionableUpdates(resource.id)}
            />
          </li>
        );
      }
    }
    return displayedActionables;
  };

  const handleSelectAllResources = (isSelected) => {
    if (isSelected) {
      const resourceKeys = [...scopeResources.map((resource) => resource.id)];
      updateSelectedKeys(resourceKeys);
      updateScope({ section_keys: resourceKeys });
    } else {
      updateSelectedKeys([]);
      updateScope(null);
    }
    updateAllSelected(isSelected);
  };

  const renderScopableList = () => {
    const selectAllCollectionsCheckbox = (
      <li className="checkbox-container" key="-1">
        <Checkbox
          checked={allScopableSelected}
          labelHtml={<h5>{t('All')}</h5>}
          size="sm"
          toggle={() => handleSelectAllResources(!allScopableSelected)}
        />
      </li>
    );

    const hideAllCheckbox = scopableSearch.length > 0;
    const checkboxes = hideAllCheckbox
      ? [formattedCheckboxes()]
      : [selectAllCollectionsCheckbox, formattedCheckboxes()];

    return (
      <ul className="resource-list-container fixed-height">
        { checkboxes }
      </ul>
    );
  };

  return (
    <React.Fragment>
      <h3>{t('Select Sections')}</h3>
      {renderScopableSearch()}
      {renderScopableList()}
    </React.Fragment>
  );
}

ScopeSectionSelection.propTypes = {
  updateScope: PropTypes.func.isRequired,
  scope: PropTypes.shape({})
};

ScopeSectionSelection.defaultProps = {
  scope: false
};

export default ScopeSectionSelection;
